import * as React from "react"
import * as Mousetrap from "mousetrap"

import { Symbols } from "@tenforce/toolbox-fontmap"
import { Selector, ItemBlockPart } from "@tenforce/toolbox-selector-react"

interface Props {
    activePanel: string
    attachmentsCount?: number
    commentsCount?: number
    showAttachments?: boolean
    showComments?: boolean
    showHistory?: boolean
    CommentsAttachmentsLabel: string
    HistoryLabel: string
    OverviewLabel: string
    onPanelSwitch: (panel: string, updateURL: boolean) => void
}

interface State {
    panel: string
}

const contentValue = "overview"
const historyValue = "history"
const commentsAndAttachmentsValue = "commentsAndAttachments"

export default class PanelSwitch extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            panel: props.activePanel,
        }
    }

    render(): JSX.Element {
        const {
            attachmentsCount,
            commentsCount,
            showAttachments,
            showComments,
            showHistory,
            CommentsAttachmentsLabel,
            HistoryLabel,
            OverviewLabel,
        } = this.props
        const { panel } = this.state

        const showCommentsAttachmentCounter =
            !!commentsCount || !!attachmentsCount
        let commentsAttachmentCounter = attachmentsCount ?? 0
        commentsAttachmentCounter += commentsCount ?? 0

        return (
            <Selector
                isRequired={true}
                isExpanded={true}
                isSingleSelect={true}
                isWrapped={false}
                data-ft-component="panelSwitch"
            >
                <ItemBlockPart
                    isSelected={
                        panel === contentValue ||
                        (panel !== commentsAndAttachmentsValue &&
                            panel !== historyValue)
                    }
                    data-ft-value={contentValue}
                    title={OverviewLabel}
                    onSelected={(): void =>
                        this.switchToPanelAndUpdateURL(contentValue)
                    }
                >
                    {Symbols.ListIcon}
                </ItemBlockPart>

                {(showComments || showAttachments) && (
                    <ItemBlockPart
                        isSelected={panel === commentsAndAttachmentsValue}
                        data-ft-value={commentsAndAttachmentsValue}
                        title={CommentsAttachmentsLabel}
                        onSelected={(): void =>
                            this.switchToPanelAndUpdateURL(
                                commentsAndAttachmentsValue,
                            )
                        }
                    >
                        {Symbols.CommentsAndAttachments}
                        {showCommentsAttachmentCounter && (
                            <sup>{commentsAttachmentCounter}</sup>
                        )}
                    </ItemBlockPart>
                )}

                {showHistory && (
                    <ItemBlockPart
                        isSelected={panel === historyValue}
                        data-ft-value={historyValue}
                        title={HistoryLabel}
                        onSelected={(): void =>
                            this.switchToPanelAndUpdateURL(historyValue)
                        }
                    >
                        {Symbols.History}
                    </ItemBlockPart>
                )}
            </Selector>
        )
    }

    componentDidMount(): void {
        const { activePanel, onPanelSwitch } = this.props
        onPanelSwitch(activePanel, false)

        Mousetrap.bind("alt+1", () =>
            this.switchToPanelAndUpdateURL(contentValue),
        )
        Mousetrap.bind("alt+2", () =>
            this.switchToPanelAndUpdateURL(commentsAndAttachmentsValue),
        )
        Mousetrap.bind("alt+3", () =>
            this.switchToPanelAndUpdateURL(historyValue),
        )
    }

    componentWillUnmount(): void {
        Mousetrap.unbind("alt+1")
        Mousetrap.unbind("alt+2")
        Mousetrap.unbind("alt+3")
    }

    switchToPanelAndUpdateURL = (panel: string): void => {
        this.props.onPanelSwitch(panel, true)

        this.setState({ panel })
    }
}
